<template>
  <div>

    <p>{{this.data}}</p>

    <div id="book" class="mb-10" style="display: grid; grid-template-columns: 1fr 1fr;">
      <div class="book-left">
        <ul>
          <li
            v-for="(mean, index) in sortedMeansA"
            :key="index"
            class="h-2 flex justify-start align-center"
            :class="setClass(mean.ref, mean.title)"
            :style="{ height: 400 / meansPerPageA + 'px'}"
          >
            <div></div>
            <span class="pl-2 font-8 txt-bold">{{ mean.title }}</span>
          </li>
        </ul>
      </div>

      <div class="book-right">
        <ul>
          <li
            v-for="(mean, index) in sortedMeansB"
            :key="index"
            class="h-2 flex justify-end align-center"
            :class="setClass(mean.ref)"
            :style="{ height: 400 / meansPerPageB + 'px'}"
          >
            <span class="pr-2 font-8 txt-bold">{{ mean.title }}</span>
            <div></div>
          </li>
        </ul>
      </div>
    </div>

  </div>
</template>

<script>
import db from '@/firebase/init'

export default {
  name: 'book',

  props: ['data'],

  data () {
    return {
      meanSpaces: [],
      meanSettings: []
      /* testaus: null */
    }
  },

  created () {
    db.collection('keinot').get().then(snapshot => {
      snapshot.docs.forEach(doc => {
        let mean = doc.data()
        if (mean.ref === 'A' || mean.ref === 'B' || mean.ref === 'C') {
          this.meanSpaces.push(mean)
        } else {
          this.meanSettings.push(mean)
        }
      })
    })
  },

  computed: {
    sortedMeansA () {
      let temp = this.meanSpaces.slice()
      temp.sort(this.compareValues('ref'))
      return temp
    },

    sortedMeansB () {
      let temp = this.meanSettings.slice()
      temp.sort(this.compareValues('ref'))
      return temp
    },

    meansPerPageA () {
      return this.sortedMeansA.length
    },

    meansPerPageB () {
      return this.sortedMeansB.length
    }
  },

  methods: {
    setClass (ref, title) {
      // let lc = 'PasKa'
      // let muutos = lc.toLowerCase()
      // console.log(muutos)

      // let lc = this.title.toLowerCase()
      // console.log(lc);
      // console.log(title.toLowerCase());
      // console.log(this.data);
      // console.log(this.data.includes(lc));

      return {
        ['group-' + ref]: true
        // disabled: true
        // disabled: this.data.includes(title.toLowerCase())
      }
    },

    // dynamic sorting function:
    compareValues (key, order = 'asc') {
      return function (a, b) {
        if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) { // property doesn't exist on either object
          return 0
        }

        const varA = (typeof a[key] === 'string') ? a[key].toUpperCase() : a[key]
        const varB = (typeof b[key] === 'string') ? b[key].toUpperCase() : b[key]

        let comparison = 0
        if (varA > varB) {
          comparison = 1
        } else if (varA < varB) {
          comparison = -1
        }
        return (
          (order === 'desc') ? (comparison * -1) : comparison
        )
      }
    }
  }
}
</script>

<style lang="scss">
@import "@/styles/styles.scss";

.book {
  width: 90vw;
  min-width: 370px;
  max-width: 500px;
}
.book-left, .book-right {
  border: 3px solid black;
  li {
    border-bottom: 1px solid rgb(210, 210, 210);
    cursor: pointer;
    &:hover { background-color: rgb(210, 210, 210); }
    div {
      width: 1.5rem;
      height: 100%;
    }
    span {

    }
  }
}
.book-left {
  border-right: 1.5px solid black;
  border-left: none;
}
.book-right {
  border-left: 1.5px solid black;
  border-right: none;
}
</style>
